import { RouteConfig } from '@Config/routes';
import {
  AdvertFragment,
  AuctionFragment,
  ForumInfoFragmentFragment,
  ForumThreadFragment,
} from '@Graphql/graphqlTypes.generated';

export const buildFullAdvertUrl = (advert: AdvertFragment) => {
  const { slug } = advert;
  return `${window.location.origin}${RouteConfig.Advert.buildLink({ slug })}`;
};

export const buildFullAuctionUrl = (auction: AuctionFragment) => {
  const { slug } = auction;
  const routeUrl = RouteConfig.AuctionPreview.buildLink({ slug });
  return `${window.location.origin}${routeUrl}`;
};

export const buildFullForumThreadListUrl = (forum: ForumInfoFragmentFragment) => {
  const { slug } = forum;
  const routeUrl = RouteConfig.ForumThreadList.buildLink({ slug });
  return `${window.location.origin}${routeUrl}`;
};

export const buildFullForumThreadUrl = (forumThread: ForumThreadFragment) => {
  const {
    slug,
    forum: { slug: forumSlug },
  } = forumThread;

  const routeUrl = RouteConfig.ForumThreadPage.buildLink({ slug, forumSlug });
  return `${window.location.origin}${routeUrl}`;
};
